export default {
    message: {
        unopen: 'not yet open!',
    },
};